// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-uploader{display:flex;align-items:center;margin-top:24px;width:100%}
`, "",{"version":3,"sources":["webpack://./src/components/editors/AssetsEditor/Upload.scss"],"names":[],"mappings":"AAAA,eACE,YAAa,CACb,kBAAmB,CACnB,eAAgB,CAChB,UAAW","sourcesContent":[".file-uploader {\n  display: flex;\n  align-items: center;\n  margin-top: 24px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
